module.exports = __webpack_public_path__ + "static/img/anxun23.e8f7b42a.png";